<template>
    <div class="paid">
        <a-page-header
            style="border: 1px solid rgb(235, 237, 240);background:#fff;padding:16px 32px"
            :breadcrumb="{ props: { routes } }"
        />

        <div class="paid-detail">
            <a-card>
                <div>
                    <div class="search">
                        <label for="">关键词：</label>
                        <a-input placeholder="输入关键词" style="width:200px;margin-right:16px"/>
                        <label for="">统计时间段：</label>
                        <a-month-picker placeholder="请选择日期" @change="onChange" :locale="locale"/>
                        <a-button type="primary" style="margin-left:14px">搜索</a-button>
                    </div>
                    <a-table
                    :columns="columns"
                    :pagination="pagination"
                    :loading="loading"
                    @change="handleTableChange"
                    :data-source="data"
                    >
                    </a-table>

                </div>
            </a-card>
        </div>


    </div>
</template>

<script>
import locale from 'ant-design-vue/es/date-picker/locale/zh_CN';
import router from "@/router/index"
const columns = [
  {
    title: 'ID',
    dataIndex: 'key',
    key: 'key',
  },
  {
    title: '流量来源',
    dataIndex: 'age',
    key: 'age',
    filters: [
      { text: '百度搜索', value: '20' },
      { text: '手机百度', value: '21' },
      { text: '360搜索', value: '22' },
      { text: '手机360', value: '24' },
      { text: '搜狗搜索', value: '25' },
      { text: '手机搜狗', value: '26' },
      { text: '神马搜索', value: '27' },
      { text: '必应搜索', value: '28' },
      { text: '中国搜索', value: '29' },
      { text: '雅虎搜索', value: '35' },
      { text: '谷歌搜索', value: '34' },
      { text: '微信小程序', value: '33' },
      { text: '百度小程序', value: '32' },
      { text: '外链推广', value: '31' },
    ],
    filterMultiple: false,
  },
  {
    title: '关键词',
    dataIndex: 'address',
    key: 'address',
  },
  {
    title: '导入时间',
    key: 'tags',
    dataIndex: 'tags',
    sorter: (a, b) => a.age - b.age,
    sortDirections: ['descend', 'ascend'],
  },
  
];
const data = [
  {
    key: '1',
    name: 'John Brown',
    age: 32,
    address: 'New York No. 1 Lake Park',
    tags: '钢化玻璃',
    url:'http://shop.zzzs2010.cn/14476/index.html?nestshop|360',
    ipaddress:'未读',
    money:'26',
  },
  {
    key: '2',
    name: 'Jim Green',
    age: 42,
    address: 'London No. 1 Lake Park',
    tags: '阳台玻璃',
    url:'http://shop.zzzs2010.cn/14476/index.html?nestshop|360',
    ipaddress:'已读',
    money:'3.2',
  },
];

export default {
    data(){
        return{
            data,
            locale,
            columns,
            pagination: {},
            loading: false,
            routes: [
                {breadcrumbName: '首页'},
                {breadcrumbName: '排名查询'},
                {breadcrumbName: '自然排名'},
            ],
        }
    },
    methods:{
        onChange(date, dateString) {
            console.log(date, dateString);
        },
        handleTableChange(pagination, filters, sorter) {
            console.log(pagination);
            const pager = { ...this.pagination };
            pager.current = pagination.current;
            this.pagination = pager;
            this.fetch({
                results: pagination.pageSize,
                page: pagination.current,
                sortField: sorter.field,
                sortOrder: sorter.order,
                ...filters,
            });
        },
    }
}
</script>




// WEBPACK FOOTER //
// src/components/ranking/paid.vue